<div>
    <div class="flex align-items-center justify-content-center mt-3">
        <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
                placeholder="Search" class=" p-inputtext-sm" />
        </span>
    </div>
&nbsp;
<p-table #dt1 [value]="result.account" [scrollable]="true" scrollHeight="350px" styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm "
[paginator]="true" [rows]="10" [globalFilterFields]="['accountName','tags','accountTypeCode','accountGroupCode','accountCode']" (onPage)="loadAccounts($event)" [(selection)]="selectedAccount"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10, 15, 20]" (onRowSelect)="SelectOption($event)">


<ng-template pTemplate="header">
<tr>
    <th>
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
    </th>
    <th>Account Code</th>
    <th>Account Name</th>
    <th>Account Type </th>
    <th>Account Group </th>
    <th>Financial Statement</th>
    <!-- <th class="text-center">Depreciated</th> -->
</tr>
</ng-template>
<ng-template pTemplate="body" let-Account>
<tr>
    <td>
        <p-tableCheckbox [value]="Account"></p-tableCheckbox>
    </td>
    <td>{{Account.accountCode}}</td>
    <td>{{Account.accountName}}</td>
    <td>{{Account.accountTypes?.accountType}}</td>
    <td>{{Account.accountGroup?.accountGroupName}}</td>
    <td>{{Account.financialStatement}}</td>
    <!-- <td class="text-center">
        @if(!Account.isDepreciated){
            <span class="pi pi-times-circle" style="color: red;"></span>
        }@else{
            <span class="pi pi-check-circle" style="color: green;"></span>
        }
    </td> -->
</tr>
</ng-template>
<ng-template pTemplate="emptymessage">
<tr>
    <td colspan="8">No Records found.</td>
</tr>
</ng-template>
</p-table>
</div>
